import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * Glossary Link
 * —
 * This component is rendered to a string and inserted into rich text content.
 * As such, it should not rely on any lifecycle hooks.
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const GlossaryLink = ({
    href,
    index,
    label,
    termId,
}) => {
    return (
        <span className='glossary-link inline-block'>
            <a
                className='glossary-term'
                data-glossary={termId}
                href={href}>
                {label}
            </a>

            {(index !== undefined) &&
                <sup className='ml-[0.25em] mr-[0.25em]'>
                    {index}
                </sup>
            }
        </span>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    href: PropTypes.string.isRequired,
    index: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    label: PropTypes.string.isRequired,
    termId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};

GlossaryLink.propTypes = propTypes;

export default GlossaryLink;
